module.exports = __webpack_public_path__ + "img/petal.236bc2d7.jpg";